shadow$provide[308] = function(global,require,module,exports) {

};